import React, { useRef, useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import apiCall from "../../../Api/api";
import { useNavigate, useParams } from "react-router-dom";
import { handleError } from "../../../Api/handleError";
import { todayIST } from "components/Api/common";
import { useToast } from "provider/ToastProvider";
import TextareaAutosize from 'react-textarea-autosize';
import { useMobileVerifyContext } from "provider/MobileVerificationProvider";
import { useAuth } from "provider/AuthContext";
import { useSafariPackagesContext } from "provider/SharePackagesProvider";
import MobileNoVerificationModal from "components/common/mobilenoverification/MobileNoVerificationModal";

const GetQuoteForm = () => {
  const navigate = useNavigate();
  const { userProfile } = useAuth();
  const { packSlug } = useParams();
  const { packageViewData } = useSafariPackagesContext();
  const maxBookingDate = packageViewData?.max_booking_date; 

  const { showErrorToast, showSuccessToast } = useToast();
  const textareaRef = useRef(null);
  const { toggleMobileVerify, mobileVerifyDispatch } = useMobileVerifyContext();
  const maxLength = 1000;
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    travelers: 1,
    pack_start_date: "",
    user_notes: ''
  });

  const [errors, setErrors] = useState({
    travelers: "",
    pack_start_date: "",
    user_notes: ''
  });

  const validate = () => {
    const newErrors = {};

    if (!formData.travelers || formData.travelers < 1) {
      newErrors.travelers = "At least one traveler is required.";
    }

    if (!formData.pack_start_date) {
      newErrors.pack_start_date = "Date is required.";
    } else if (formData.pack_start_date < todayIST) {
      newErrors.pack_start_date = "Date cannot be in the past.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const submitForm = async () => {
    if (!validate()) return;
    if (!userProfile?.is_mobile_no_verified) {
      mobileVerifyDispatch({ type: "MOBILE_VERIFY_TOGGLE", payload: true });
      return;
    }

    try {
      setLoading(true);
      const formDataSubmit = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '' && value !== 0) {
          formDataSubmit.append(key, value);
        }
      });

      const response = await apiCall({
        url: `package/${packSlug}/package-quote`,
        method: "POST",
        data: formDataSubmit,
      });

      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      const apiData = response.data;

      if (apiData?.status === 1) {
        showSuccessToast(apiData?.message);
        setFormData({
          travelers: 1,
          pack_start_date: "",
          user_notes:""
        });
        setErrors({
          travelers: "",
          pack_start_date: "",
          user_notes:''
        });
      } else {
        showErrorToast(apiData?.message)
        console.error("error:", apiData?.message)
      }

    } catch (error) {
      handleError(error, null, navigate);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submitForm();
  };
  const update = (name, value) => {
    setFormData({ ...formData, [name]: value });
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleChangeNotes = (e) => {
    const value = e.target.value.slice(0, maxLength);
    const trimmed = value.trim() ? value : '';
    setFormData({
      ...formData,
      user_notes: trimmed
    });
    setErrors({
      ...errors,
      user_notes: ''
    });
  };


  return (
    <>
      <div className="request_quote mb-4 position-relative">
        <button
          className="intested_btn interestBtn"
          style={{
            backgroundColor: "var(--background-primary)",
            cursor: "default",
          }}
        >
          Request Quote
        </button>

        <div className="interst_wrapper p-0 bg-white">
          <div className="users_profile d-flex gap-3 align-items-start flex-wrap">
            <div className="col-12">
              <div className="getquote_box bg-white border_setgetting">
                <Form id="quoteform" onSubmit={handleSubmit}>
                  <Row className="gy-3">
                    <Col xs={12} md={5}>
                      <Form.Group controlId="travelers">
                        <Form.Label>Travelers</Form.Label>
                        <Form.Control
                          type="number"
                          name="travelers"
                          value={formData.travelers}
                          onChange={(e) => update("travelers", e.target.value)}
                          min="1"
                          isInvalid={!!errors.travelers}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.travelers}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col xs={12} md={7}>
                      <Form.Group controlId="pack_start_date">
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="pack_start_date"
                          value={formData.pack_start_date}
                          min={todayIST}
                          max={maxBookingDate}
                          onChange={(e) => update("pack_start_date", e.target.value)}
                          onKeyDown={(e) => e.preventDefault()}
                          isInvalid={!!errors.pack_start_date}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.pack_start_date}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={12}>
                      <div className="form-wrapper ">
                        <Form.Label className="m-0 p-0">Additional Notes</Form.Label>
                        <TextareaAutosize
                          ref={textareaRef}
                          name="Chat[user_notes]"
                          placeholder="Type a Message"
                          className="form-control  hide-scrollbar text-area-commet"
                          value={formData?.user_notes}
                          onChange={handleChangeNotes}
                          maxLength={maxLength}
                          minRows={3}
                          maxRows={10}
                        />
                      </div>
                    </Col>

                    <Col xs={12}>
                      <Button
                        type="submit"
                        className="sent_btn rounded-2 w-100"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Show Interest"}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {toggleMobileVerify && <MobileNoVerificationModal handleSubmit={submitForm} title="You need to verify your phone number" />}
    </>

  );
};

export default GetQuoteForm;
